import { lazy } from 'react';

export const Table = lazy(() => import(`~components/Table`));
export const FrDisabilityGapSimulator = lazy(
  () => import(`~components/ContentfulComponentCustom/FrDisabilityGapSimulator`),
);
export const JobPostings = lazy(() => import(`~components/ContentfulComponentCustom/JobPostings`));
export const ContentfulComponentHeaderToptasks = lazy(() => import(`~components/ContentfulComponentHeaderToptasks`));
export const ContentfulComponentLogoBar = lazy(() => import(`~components/ContentfulComponentLogoBar`));
export const ContentfulComponentProductCards = lazy(() => import(`~components/ContentfulComponentProductCards`));
